import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  root: {
    width: "100%",
    rowGap: "16px",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    boxSizing: "border-box",
    padding: "16px 40px",
    columnGap: "30%",
    "&:hover": { cursor: "pointer" },
  },
  loading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%",
    gap: "16px",
  },
  item: {},
});

export default useStyles;
